import React, { useState } from "react";
import axios from "axios";

import {
	Container,
	FormContainer,
	ImageContainer,
	Title,
	Subtitle,
	Form,
	InputContainer,
	Image,
	ButtonContainer,
	LeftContainer,
	SuccessMessage,
} from "./styles";

import Select from "../HeroBanner/Select";
import { Button } from "../../Elements";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";
import Input from "../HeroBanner/Input";

const OutcomesBanner = (props) => {
	const [showError, setErrorFlag] = useState(false);
	const [errorMessage, setErrorMessage] = useState(false);
	const [reportValue, setReportValue] = useState(null);
	const [email, setEmail] = useState(null);
	const [interestedAPIResponse, setinterestedAPIResponse] = useState(null);

	const errorMessages = {
		required_error_message: "This field is required",
	};

	const validateEmail = (value) => {
		const emailRegex =
			/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
		if (emailRegex.test(value)) {
			return true;
		}
		if (value && value.length) {
			setErrorMessage("Please enter a valid email address");
		} else {
			setErrorMessage("This field is required");
		}
		return false;
	};

	const handleInputChange = ({ target: { value } }) => {
		return setEmail(value.trim());
	};
	const handleOnFocus = () => {
		setErrorMessage(false);
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		if (!email) {
			setErrorMessage("This field is required");
		}
		if (!reportValue) {
			setErrorFlag(true);
		}

		if (!email || !reportValue || showError) {
			return;
		}

		var bodyFormData = new FormData();
		bodyFormData.append("email", email);
		bodyFormData.append("lead_type", "OU");
		bodyFormData.append("workshop_id", reportValue.workshop_id);

		const baseUrl =
			props.apiBaseUrl ||
			`${window.location.protocol}//${window.location.host}`;

		axios({
			method: "POST",
			url: `${baseUrl}/learning-paths/interested/`,
			data: bodyFormData,
			headers: { "Content-Type": "multipart/form-data", withCredentials: true },
		})
			.then((res) => {
				setinterestedAPIResponse(res.data);
			})
			.catch((err) => {
				console.error({ err });
			});
	};
	return (
		<Container>
			<LeftContainer>
				<FormContainer>
					<Title>{props.title}</Title>
					<Subtitle show={!interestedAPIResponse}>{props.subtitle}</Subtitle>

					<Form show={!interestedAPIResponse} onSubmit={handleSubmit}>
						<InputContainer>
							<Input
								name="email"
								type="email"
								placeholder="Email"
								onChange={handleInputChange}
								onFocus={handleOnFocus}
								onBlur={(e) => validateEmail(e.target.value)}
								errorMessage={errorMessage}
							></Input>
						</InputContainer>
						<InputContainer>
							<Select
								value={{}}
								placeholder="Choose your program"
								isRequired={true}
								fullWidth={true}
								optionDisplayKey="course_name"
								optionValueKey="workshop_id"
								options={props.reports_available}
								errorMessages={errorMessages}
								showError={showError}
								emitFocusEvent={() => {
									setErrorFlag(false);
								}}
								emitChangeEvent={(item) => {
									setReportValue(item);
								}}
								onClick={(e) => {
									alert(e);
								}}
							/>
						</InputContainer>
						<ButtonContainer>
							<Button>Download the report</Button>
						</ButtonContainer>
					</Form>
					{interestedAPIResponse && (
						<SuccessMessage>
							<div>The report is on the way to your mailbox!</div>
						</SuccessMessage>
					)}
				</FormContainer>
			</LeftContainer>
			<ImageContainer>
				<Image>
					<CloudinaryImage
						url={props.image.image}
						lazyload
						sizes={{ default: { width: 450 }, "322px": { width: 400 } }}
					/>
				</Image>
			</ImageContainer>
		</Container>
	);
};

export default OutcomesBanner;
